export const VPN_IOS_URL = 'https://protonvpn.com/download-ios';
export const VPN_ANDROID_URL = 'https://protonvpn.com/download-android';
export const VPN_APPLE_TV_URL = 'https://protonvpn.com/download-appletv';
export const VPN_DESKTOP_MAC_URL = 'https://protonvpn.com/download-mac';
export const VPN_DESKTOP_WINDOWS_URL = 'https://protonvpn.com/download-windows';
export const VPN_DESKTOP_LINUX_URL = 'https://protonvpn.com/download-linux';
export const VPN_HUB_URL = 'https://protonvpn.com/download';

export const VPN_MOBILE_APP_LINKS = {
    appStore: 'https://itunes.apple.com/app/id1437005085',
    playStore: 'https://play.google.com/store/apps/details?id=ch.protonvpn.android',
};
